export const loanInfoConstants = {
    GET_USER_LOAN_VIEWS: 'LOAN_INFO_GET_USER_LOAN_VIEWS',
    USER_ACCOUNT_HISTORY: 'LOAN_INFO_VIEW_ACCOUNT_HISTORY',
    USER_ACCOUNT_LOAD_ACCOUNT_HISTORY: 'LOAN_INFO_LOAD_ACCOUNT_HISTORY',
    MAKE_PAYMENT: 'MAKE_PAYMENT', 
    GENERIC_FAILURE : 'GENERIC_FAILURE',
    LOAD_USER_LOAN_VIEWS_SUCCESS: 'LOAD_USER_LOAN_VIEWS_SUCCESS',
    LOAD_ACCOUNT_ACTIVITY_SUCCESS: 'LOAD_ACCOUNT_ACTIVITY_SUCCESS',
    TOGGLE_PAYMENT_SCHEDULED_VIEW: 'TOGGLE_PAYMENT_SCHEDULED_VIEW', 
    TOGGLE_ACTIVITY_VIEW: 'TOGGLE_ACTIVITY_VIEW',
    CLEAR_USER_LOAN_INFO: 'CLEAR_USER_LOAN_INFO', 
    NUMBER_REFERRALS_EARNED_LOADED: 'NUMBER_REFERRALS_EARNED_LOADED', 
    LEADS_LOADED: 'LEADS_LOADED', 
    LAST_LEAD_LOADED: "LAST_LEAD_LOADED",
    INVALIDATE_LOANS_STATE: "INVALIDATE_LOANS_STATE",
    BANNER_DATA_LOADED: "BANNER_DATA_LOADED"
};
